import React from "react";
import clsx from "clsx";

import * as Button from "components/Button";
import { TopicsType, BestPracticesType } from "templates/resource-hub/types";

import * as styles from "./styles.module.scss";

type ResourceHubPopularSearchProps = {
  activeItems?: string[];
  handlePopularSearchTag?: (id: string) => void;
  isPostPage?: boolean;
  popularSearchTags: BestPracticesType[] | TopicsType[];
  showActiveStyles: boolean;
  title?: string | null;
};

const PopularSearch: React.FC<ResourceHubPopularSearchProps> = ({
  activeItems,
  handlePopularSearchTag,
  isPostPage,
  popularSearchTags,
  title = "Popular searches:",
}) => {
  const className = clsx(styles.searches, isPostPage && styles.isPostPage);
  return popularSearchTags && popularSearchTags.length > 0 ? (
    <div className={className}>
      {title && <h4>{title}</h4>}
      <ul>
        {popularSearchTags.map((item: BestPracticesType | TopicsType, key) => {
          const active = activeItems?.includes(item.slug);
          const itemClassName = clsx(
            styles.tag,
            styles[`${(item as BestPracticesType)?.colour}`],
            active && styles.active
          );
          return (
            <React.Fragment key={item.id + key}>
              <li className={itemClassName}>
                {handlePopularSearchTag ? (
                  <Button.Generic label={item?.title} onClick={() => handlePopularSearchTag(item.slug)} />
                ) : (
                  <div>
                    <span>{item?.title}</span>
                  </div>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default PopularSearch;
